import React from "react";
import { useNavigate } from "react-router-dom"; // Ensure correct import
import image from "../../assets/banner/homeconat.jpeg";
import image2 from "../../interior_assets/header-image/banner-2.jpeg";
import "./homemain.css";

function Homemain() {
  const navigate = useNavigate();

  return (
    <div className="gallery">
      <div className="image-containerr">
        <img src={image} alt="A Bear" />
        <h2 className="overlayy" onClick={() => navigate("/constructionpage")}>
          Welcome to Construction
        </h2>
      </div>
      <div className="image-containerr">
        <img src={image2} alt="A Tiger" />
        <h2 className="overlayy" onClick={() => navigate("/interiorpage")}>
          Welcome to Interior
        </h2>
      </div>
    </div>
  );
}

export default Homemain;
